module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/~/babel-runtime/regenerator/index.js
// module id = 515
// module chunks = 0